import { store } from '../store/store';
import { locationsApiSlice } from '../api/locations/locationsApiSlice';
import { setAssetGroups } from '../store/slices/bookingCreationNonRoomRentalSlice';
import Logger from '../common/logger';

export const useFetchGroups = (locationId: string | undefined) => {
    return async () => {
        if (!locationId) {
            Logger('fetchGroupsFlow').log('Location ID is required to fetch groups');
            return;
        }

        try {
            const result = await store.dispatch(
                locationsApiSlice.endpoints.getGroupsWithPrices.initiate(locationId),
            );

            if (result.data) {
                store.dispatch(setAssetGroups({ groups: result.data }));
            }
        } catch (error) {
            Logger('fetchGroupsFlow').log(`Error fetching groups: ${error}`);
        }
    };
};
